import { render, staticRenderFns } from "./UpdateCompete.vue?vue&type=template&id=00153a3f&scoped=true&"
import script from "./UpdateCompete.vue?vue&type=script&lang=js&"
export * from "./UpdateCompete.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCompete.vue?vue&type=style&index=0&id=00153a3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00153a3f",
  null
  
)

export default component.exports